import React from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    role: 'Former CEO',
    outcome: 'Successful board appointment',
    quote: 'The strategic repositioning of my resume was instrumental in securing my first independent director seat. They understood exactly how to translate my operational success into governance value.'
  }, {
    role: 'Board Chairman',
    outcome: 'Enhanced leadership visibility',
    quote: 'I needed a narrative that reflected my tenure and vision without reading like a standard CV. The resulting board biography and resume perfectly captured my legacy and strategic oversight capabilities.'
  }, {
    role: 'Independent Director',
    outcome: 'Better interview opportunities',
    quote: "Their process is rigorous and deeply introspective. The final documents didn't just list my achievements; they articulated my unique value proposition to nominating committees."
  }, {
    role: 'Chief Information Officer',
    outcome: 'Executive promotion',
    quote: 'Transitioning from a technical leader to a strategic business partner required a complete brand overhaul. Their team delivered a resume that opened doors at the highest levels.'
  }, {
    role: 'Chief Financial Officer',
    outcome: 'Improved LinkedIn presence',
    quote: 'The LinkedIn optimization completely changed my inbound inquiries. I am now regularly approached by top-tier search firms for roles that perfectly align with my career goals.'
  }, {
    role: 'Healthcare Executive',
    outcome: 'Board candidate positioning',
    quote: "They possess a rare understanding of the healthcare sector's regulatory and governance demands. My new portfolio positioned me flawlessly for a critical advisory board role."
  }];
  return <section id="testimonials" className="py-24 bg-gray-50" data-id="element-422">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-423">
        <div className="text-center mb-16" data-id="element-424">
          <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-425">
            Success Stories
          </span>
          <h2 className="text-3xl md:text-5xl font-serif-display font-bold text-navy-900 mb-6" data-id="element-426">
            Trusted by Top Executives
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-427">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 relative" data-id="element-428">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-navy-50" data-id="element-429" />
              <div className="mb-6" data-id="element-430">
                <div className="font-bold text-navy-900 text-lg" data-id="element-431">
                  {testimonial.role}
                </div>
                <div className="text-gold text-sm font-semibold uppercase tracking-wider mt-1" data-id="element-432">
                  {testimonial.outcome}
                </div>
              </div>
              <p className="text-gray-600 italic leading-relaxed relative z-10" data-id="element-433">
                "{testimonial.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}